module.exports = __webpack_public_path__ + "img/cloud-big-blue.84b03778.png";